// extracted by mini-css-extract-plugin
export default {"confirmation-modal":"components-settings-cost-modals-delete-profile-module__confirmation-modal"};